import BrowserNeedUpdate from "src/components/System/BrowserNeedUpdate";
import BodyLanding from "../components/Landing/BodyLanding";
import Navbar from "../components/Landing/Navbar";
import { useState } from "react";
import DialogInfoGeneral from "src/components/Shared/DialogInfoGeneral";
import img from "src/assets/images/logo/BannerISFLG.png";
import SafariAlert from "src/components/Shared/SafariAlert";
import VersionCheck from "src/components/Shared/VersionCheck";
const Landing = () => {
  const [maintenance, setMaintenance] = useState(false);
  const [counter, setCounter] = useState(0);

  const handle = () => {
    setCounter(counter + 1);
    if (counter > 9) {
      setMaintenance(false);
    }
  };
  return (
    <div>
      {!maintenance && <Navbar />}
      <SafariAlert />
      <VersionCheck />
      <BrowserNeedUpdate />
      {!maintenance ? (
        <BodyLanding />
      ) : (
        <div>
          <DialogInfoGeneral
            show={true}
            disabledClosable={true}
            disabledFooter={true}
            size="xl"
            closeDialog={() => null}
          >
            <div className="px-10 py-20">
              <div className="text-center text-lg opensans">
                Estamos realizando tareas de mantenimiento para mejorar nuestros
                servicios.
                <div className="py-4">
                  Volveremos a estar en línea a la brevedad. Gracias por su
                  paciencia...
                </div>
                <img
                  onClick={() => handle()}
                  src={img}
                  alt="isf"
                  className="w-20 mx-auto mb-4"
                />
              </div>
            </div>
          </DialogInfoGeneral>
        </div>
      )}
    </div>
  );
};

export default Landing;
